module.exports = __webpack_public_path__ + "img/DSC04325-3.4b572f45.jpg";